<template>
  <v-app
    id="core-app-view"
    :style="{ maxWidth: screenWidth }"
  >
    <div>
      <app-core-view />
      <alert />
      <!-- <version-update-dialog
        v-model="showUpdateDialog"
        title="App Update"
        message="A new version of this app is ready. Please refresh to continue with the latest updates and improvements."
        confirm-button="Update now"
        @confirmed="reloadApp"
      /> -->
    </div>
  </v-app>
</template>
<script>
import '../../../node_modules/@mdi/font/css/materialdesignicons.css';
import AppCoreView from './AppCoreView.vue';
import Alert from '@/components/Alert';

export default {
  name: 'App',
  components: { AppCoreView, Alert },
  data: () => ({}),
  computed: {
    screenWidth () {
      if (this.$route.path.includes('/device')) {
        return '100%';
      } else {
        return '900px';
      }
    },
    userDetails () {
      return this.$store.getters['userprofile/getUserDetails'];
    },
  },
  watch: {
    showUpdateDialog (newVal, oldVal) {
      if (newVal === true) {
        this.reloadApp();
      }
    },
  },
  mounted () {
    document.addEventListener('visibilitychange', this.handleVisibility);
    this.checkAppUserChange();
  },
  methods: {
    // Temporary fix
    handleVisibility () {
      if (document.visibilityState === 'visible') {
        this.checkAppUserChange();
      }
    },
    async checkAppUserChange () {
      const data = localStorage.getItem('selectedOrganization');
      const parsedData = JSON.parse(data);
      if (data) {
        this.$store.dispatch('userprofile/fetchUserDetails').then(() => {
          const newAppUserRole =
            this.userDetails.selected_organization.app_user_role;
          const deviceAppUserRole = parsedData.app_user_role;
          if (newAppUserRole !== deviceAppUserRole) {
            localStorage.setItem(
              'selectedOrganization',
              JSON.stringify(this.userDetails.selected_organization),
            );
            window.location.reload();
          }
        });
      }
    },
    async reloadApp () {
      const res = await fetch('/version.json', { cache: 'no-store' });
      const data = await res.json();
      localStorage.setItem('appVersion', data.version);
      window.location.reload(true);
    },
  },
};
</script>

<style lang="css">
#app {
  background: white;
}

#core-app-view {
  display: flex;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;
}
</style>
